import React, { type MouseEvent, type ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { pushToGTM } from '../../../../shared/utis/gtm'

type Tracking = {
  event: string
  tagName: string
}

type HomeLinkProps = {
  children: ReactNode
  className?: string
  to: string
  tracking?: Tracking
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void
}

const isExternalUrl = (url: string) => /^https?:\/\//i.test(url)

const HomeLink = ({ children, className, to, tracking, onClick }: HomeLinkProps) => {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (tracking) {
      pushToGTM(tracking)
    }

    onClick?.(event)
  }

  if (isExternalUrl(to)) {
    return (
      <a className={className} href={to} target="_blank" rel="noreferrer" onClick={handleClick}>
        {children}
      </a>
    )
  }

  return (
    <Link className={className} to={to} onClick={handleClick}>
      {children}
    </Link>
  )
}

export default HomeLink
